export enum MyExamsTab {
  ToCome = "ToCome",
  Results = "DocumentsAndResults",
}
